export const RESOLVING_OPTION_LABEL = 'Cargando…';

interface ResolveSelectedOptionLabelParams {
  /** true mientras la query que trae el nombre sigue en vuelo. */
  isResolving: boolean;
  /** Texto neutro cuando no se pudo resolver el nombre. */
  fallback: string;
}

/**
 * Etiqueta de un valor ya seleccionado cuyo nombre se resuelve con una query
 * aparte. Nunca cae al id: mientras resuelve muestra "Cargando…" y, si el
 * nombre no llega, un texto neutro. Mostrar el UUID crudo confunde al usuario.
 */
export const resolveSelectedOptionLabel = (
  name: string | null | undefined,
  { isResolving, fallback }: ResolveSelectedOptionLabelParams
): string => {
  const trimmedName = name?.trim();
  if (trimmedName) return trimmedName;
  return isResolving ? RESOLVING_OPTION_LABEL : fallback;
};
